var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-row", {
    attrs: {
      type: "flex",
      align: "middle"
    }
  }, [_c("a-slider", {
    staticStyle: {
      flex: "1"
    },
    attrs: {
      value: _vm.value,
      min: _vm.min,
      max: _vm.max
    },
    on: {
      change: function change(val) {
        return _vm.$emit("input", val);
      }
    }
  }), _c("a-input-number", {
    staticStyle: {
      width: "60px"
    },
    attrs: {
      value: _vm.value,
      max: _vm.max,
      min: _vm.min
    },
    on: {
      change: _vm.handleChange
    }
  }), _vm._v(" " + _vm._s(_vm.suffix) + " ")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };